
import { pubKeyEditSeed } from '../actions.js';
import { randomBytes } from 'crypto';

export function generateRandomSeed(action$) {
    return action$.ofType('PUBKEY-GENERATE-SEED')
        .map(function newSeed() {
            const rand = randomBytes(32).toString('hex');
            return pubKeyEditSeed(rand);
        })
};




// WEBPACK FOOTER //
// ./src/epics/publickey-epics.js